import React, { useEffect, useRef } from "react";
import { useConfig } from "@/context/ConfigContext";
import axios from "axios";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

let gisLoaded = null;
function loadGIS() {
  if (window.google && window.google.accounts && window.google.accounts.id) return Promise.resolve();
  if (gisLoaded) return gisLoaded;
  gisLoaded = new Promise((res, rej) => {
    const s = document.createElement("script");
    s.src = "https://accounts.google.com/gsi/client";
    s.async = true; s.defer = true;
    s.onload = res; s.onerror = rej;
    document.head.appendChild(s);
  });
  return gisLoaded;
}

export default function GoogleLoginBtn({ onSuccess }) {
  const { google_client_id } = useConfig();
  const { login } = useAuth();
  const ref = useRef(null);

  useEffect(() => {
    if (!google_client_id) return;
    loadGIS().then(() => {
      if (!window.google || !ref.current) return;
      window.google.accounts.id.initialize({
        client_id: google_client_id,
        callback: async (resp) => {
          try {
            const r = await axios.post("/api/auth/google", { credential: resp.credential });
            login(r.data);
            toast.success(`Hola, ${r.data.name || r.data.email}`);
            onSuccess && onSuccess(r.data);
          } catch (e) {
            toast.error("No se pudo iniciar sesión con Google");
          }
        },
      });
      window.google.accounts.id.renderButton(ref.current, {
        theme: "filled_black", size: "large", text: "continue_with", shape: "rectangular",
      });
    }).catch(() => {});
  }, [google_client_id, login, onSuccess]);

  return <div ref={ref} data-testid="google-login-btn" />;
}
